export const localStorageLogoutCleanUp = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('redux');
}